import React from 'react'
import Header from './components/header'
import Footer from './components/footer'
import Main from './main'
import {PAGES} from './constants'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import {
  updateFeedData,
  updateIsFetchingFeedData,
  updateIsLoggedIn,
  logoutUser,
} from './actions'
import api from './api'
import {hot} from 'react-hot-loader'
import ToS from './components/tos'
import {getAllUserData} from './helpers/syncing'
import {updateBarleyCost} from './actions'
import * as at from './actionTypes'
import _ from 'lodash'

@withRouter
@connect((state) => {
  const {
    app: {isLoggedIn},
    userData: {didAcceptToS, userId},
    defaultNumbers: {
      global: {barleyCostUserSet},
    },
  } = state
  return {
    isLoggedIn,
    userId,
    didAcceptToS,
    barleyCostUserSet,
  }
})
@api
class App extends React.Component {
  constructor(props) {
    super(props)
    const {
      isLoggedIn,
      userId,
      dispatch,
      apiInstance,
      barleyCostUserSet,
    } = this.props

    if (isLoggedIn) {
      getAllUserData(apiInstance, {userId}, dispatch)
    }

    if (!isLoggedIn && !barleyCostUserSet) {
      apiInstance
        .get('getbarleyCost')
        .then((response) => {
          if (response && response.status === at.API_OK) {
            dispatch(updateBarleyCost(response.barleycost))
          }
        })
        .catch((err) => {})
    }
  }

  componentDidMount() {
    const {dispatch, apiInstance} = this.props

    dispatch(updateIsFetchingFeedData(true))
    apiInstance.get('getdata').then((data) => {
      dispatch(updateFeedData(data))
      dispatch(updateIsFetchingFeedData(false))
    })
  }

  handleLogOut() {
    const {dispatch, history} = this.props
    dispatch(updateIsLoggedIn(false))
    dispatch(logoutUser())
    history.push('/login')
  }

  render() {
    const {didAcceptToS, isLoggedIn} = this.props
    const pathname = window.location.pathname

    let pages = Object.values(PAGES)
    return (
      <div id="app">
        <div className="overlay">
          <Header
            isLoggedIn={isLoggedIn}
            handleLogOut={() => this.handleLogOut()}
            pages={pages}
          />
          {didAcceptToS ||
          _.includes(pathname, '/login') ||
          _.includes(pathname, '/contact') ? (
            <Main />
          ) : (
            <ToS />
          )}
          <Footer />
        </div>
      </div>
    )
  }
}

export default hot(module)(App)



// WEBPACK FOOTER //
// ./src/app.js